import Container from "../../Components/Container";
import Row from "../../Components/Row";
import Logo from "../../assets/images/logo.svg";
import Menu from "../../Components/Menu";
import Button from "../../Components/Button";
import MenuMobile from "../../Components/MenuMobile";
import { useEffect, useState } from "react";
import { NavLink } from "../../types/nav";

interface HeaderProps {
  links?: NavLink[];
}

const Header: React.FC<HeaderProps> = ({ links }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  const redirect = () => {
    window.location.href = "https://app.alfredchat.com.br";
  };

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isDesktop = window.innerWidth > 576;

  return (
    <Container
      style={{
        marginBottom: isDesktop ? "10px" : 0,
        position: isDesktop ? "fixed" : "static",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: "#000000",
        transition: "all 0.3s ease",
        paddingTop: isScrolled ? "6px" : "20px",
        paddingBottom: isScrolled ? "6px" : "20px",
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.99)",
      }}
    >
      <Row
        xs="100%"
        sm="120px auto 144px"
        md="140px auto 144px"
        lg="160px auto 144px"
        xl="180px auto 144px"
        style={{
          marginTop: isScrolled ? "0px" : "20px",
          alignItems: "center",
          transition: "margin 0.3s ease",
        }}
      >
        <img
          src={Logo}
          alt="logo"
          style={{
            width: isScrolled ? "60%" : "80%",
            transition: "width 0.3s ease",
            margin: "auto",
            marginTop: !isDesktop ? "50px" : "auto",
          }}
        />

        {window.innerWidth > 567 ? (
          <Menu links={links} />
        ) : (
          <MenuMobile links={links} />
        )}

        {isDesktop && (
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button onClick={redirect} style={{ color: "#000" }}>
              Entrar
            </Button>
          </div>
        )}
      </Row>
    </Container>
  );
};

export default Header;
